export const FIELD_NAME = 'phone_number' as const;

export const NUMBERS_TO_EXCLUDE_FROM_PREFIX_REGEX = ['IT'];
